import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import FaithJourneyStepper from "@/components/faith_journey/FaithJourneyStepper";

/**
 * Compact "My Faith Journey" card for dashboards. Renders the stepper
 * (read-only preview) with a link into the full page for edits.
 */
export default function FaithJourneyCard() {
  const [journey, setJourney] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/faith-journey/me");
        setJourney(data);
      } catch {
        /* if endpoint 403s we simply don't render */
      } finally {
        setLoaded(true);
      }
    })();
  }, []);

  if (!loaded || !journey) return null;

  return (
    <section className="patria-card p-6" data-testid="dashboard-faith-journey-card">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex items-start gap-3">
          <div className="h-11 w-11 rounded-full bg-terracotta-500/15 text-terracotta-600 flex items-center justify-center shrink-0">
            <Heart className="h-5 w-5" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-widest text-terracotta-500 font-medium">
              My Faith Journey
            </p>
            <p className="font-serif text-2xl text-forest-900 mt-1">
              Where God Is Meeting You
            </p>
            <p className="text-xs text-charcoal-muted mt-1 max-w-xl">
              Track the milestones of your life with Patria — no bureaucracy, just a warm record
              of grace. Add dates in any order; empty steps stay open.
            </p>
          </div>
        </div>
        <Link
          to="/faith-journey"
          className="patria-btn-secondary text-sm"
          data-testid="dashboard-open-faith-journey"
        >
          Open My Journey
        </Link>
      </div>

      <div className="mt-5">
        <FaithJourneyStepper journey={journey} compact />
      </div>
    </section>
  );
}
